import { getCookies } from './document.cookie';
import { getQueryFromWindow } from './window.query';

const FP_SESSION_COOKIE = 'fp_mws_profileid';
const LEGACY_COOKIE = 'mws_profileid';
const ESTABLISH_URL = process.env.REACT_APP_ESTABLISH_URL!;
const HOME_REDIRECT_URL = process.env.REACT_APP_HOME_REDIRECT_URL!;

const halt = () => new Promise<void>(() => { /* never resolves; redirect in flight */ });

// HOME_REDIRECT_URL points at the SPA's own /login (e.g. mws.fiscalpop.com/login),
// so the no-identity fallback would loop on auth pages without this guard.
const isAuthPath = (pathname: string) =>
    pathname === '/login' ||
    pathname.startsWith('/login/') ||
    pathname === '/register' ||
    pathname.startsWith('/register/') ||
    pathname.startsWith('/token/');

export async function bootstrapSession(): Promise<void> {
    const query = getQueryFromWindow();
    const cookies = getCookies();

    // Account-switch landed here with legacy query — forward to establish, BE mints cookie and 302s back.
    if (query[LEGACY_COOKIE]) {
        window.location.replace(`${ESTABLISH_URL}${window.location.search}`);
        return halt();
    }

    // Cookie present → SPA boots directly. Drop the legacy backup; cookie is source of truth from here.
    if (cookies[FP_SESSION_COOKIE]) {
        localStorage.removeItem(LEGACY_COOKIE);
        return;
    }

    // Migrate any leftover legacy cookie / localStorage token via establish.
    const legacyB64 = localStorage.getItem(LEGACY_COOKIE) || cookies[LEGACY_COOKIE];
    if (legacyB64) {
        const raw = atob(legacyB64);
        // Drop the backup pre-redirect so a failing establish can't loop us back through this branch.
        localStorage.removeItem(LEGACY_COOKIE);
        window.location.replace(`${ESTABLISH_URL}?mws_profileid=${encodeURIComponent(raw)}`);
        return halt();
    }

    if (isAuthPath(window.location.pathname)) {
        return;
    }

    window.location.replace(HOME_REDIRECT_URL);
    return halt();
}
